






































































































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '@root/common/config';
import { CHANNEL_LIST_CREATE, CHANNEL_LIST_EDIT, CHANNEL_LIST_GRANT, CHANNEL_LIST_DETAIL } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';

import {
  queryChannelList,
  exportChannelList,
  editInfoChannelList,
  forbidChannelList,
  getParkAreaList,
  setShortCode,
  enableOrDisabledShortCode,
  getChannelQRCode
} from '../../../api/parking-lot-management/index';
import Utils from '@root/utils/common';
import { dictuserModeMap, dictChannelTypeMap } from '../../../types/parking-lot-management/dictionaries';
import { API_SERVER } from '@root/common/config';
import { isShiDaill } from '@root/utils/env';
import QRCode from 'qrcodejs2';

// form表单项定义
export interface IForm {
  payUrl: string; //通道支付码链接
  noPlateEnterUrl: string; //无牌车入场码链接
  noPlateExitUrl: string; //无牌车出场码链接
}
@Component
export default class ChannelList extends Mixins(TableMixin, TableWidthMixin) {
  //判断是否是时代邻里
  isshidaill: boolean = isShiDaill;

  queryChannelListDebounce: any = function() {}; // 列表防抖请求
  checkParkId: '';
  channelId = ''; // 通道Id
  parkId = ''; // 车场ID,多个车场ID逗号分隔
  areaName = ''; // 区域名称
  channelName = ''; // 通道名称
  channelType = ''; //通道类型 00 ：入场 01 ： 出场
  status = '02'; //使用状态:01生效，00无效，02全部
  detailList = {}; //详情数据
  parkAreaArr = [];
  tableLoading = false; //表单数据loading
  dataForm = {
    payUrl: '', //通道支付码链接
    noPlateEnterUrl: '', //无牌车入场码链接
    noPlateExitUrl: '', //无牌车出场码链接
    parkName: '', //车场名称
    areaName: '', //所属区域
    channelName: '' //通道名称
  };
  shortCodeForm = {
    payUrlStatus: false,
    noPlateEnterUrlStatus: false,
    noPlateExitUrlStatus: false
  };
  // 通道类型选项
  // @Getter('dictionaries/channelType')
  // channelTypeMap?:object
  // get channelTypeOptions():any[] {
  //   return Utils.toLabelVal(this.channelTypeMap)
  // }
  // @ts-ignore
  channelTypeOptions: IOption[] = Utils.toLabelVal(dictChannelTypeMap);
  // 通道类型选中值,
  channelTypeCheckedList: (string | number)[] = this.channelTypeOptions.map(item => item.value);
  // 使用状态切换
  // @ts-ignore
  dictuserModeOptions: IOption[] = Utils.toLabelVal(dictuserModeMap);
  // value: string = ''
  // 表单
  form: any = null;
  tableData: any[] = []; // 表数据
  // visible: boolean = false
  isvisible: boolean = false;
  // 车场名称/ 区域名称下拉框
  parkAreaList: any[] = [];
  isShowEnter: boolean = false;
  listJson = { areaIds: [], parkIds: [] };
  switchTip: string = '开启则下发该短码将展示在LED屏，关闭则边缘侧LED屏不展示。';
  formData = {
    parkName: '',
    areaName: '',
    channelName: ''
  };

  @Watch('isvisible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
  }
  // model点击取消关闭model
  closeModelSub() {
    this.isvisible = false;
  }
  // 点击详情
  toDetail(channelId: string) {
    // this.channelId = channelId
    // this.showEditInfoChannelList()
    // this.visible = true
    this.$router.push({
      name: CHANNEL_LIST_DETAIL,
      params: {
        channelId
      }
    });
  }
  showModalSmall(record: Record<string, any>) {
    const {
      payUrl,
      noPlateEnterUrl,
      noPlateExitUrl,
      payUrlStatus,
      noPlateEnterUrlStatus,
      noPlateExitUrlStatus,
      parkName,
      areaName,
      channelName
    } = record;
    this.isShowEnter = record.channelType == '出口' ? true : false;
    this.channelId = record.channelId;
    this.checkParkId = record.parkId;

    this.dataForm = { payUrl, noPlateEnterUrl, noPlateExitUrl, parkName, areaName, channelName };
    this.shortCodeForm = {
      payUrlStatus: payUrlStatus === '01' ? true : false,
      noPlateEnterUrlStatus: noPlateEnterUrlStatus === '01' ? true : false,
      noPlateExitUrlStatus: noPlateExitUrlStatus === '01' ? true : false
    };
    this.isvisible = true;

    this.$nextTick(function() {
      if (this.isShowEnter) {
        let paycode = document.querySelector('#paycode');
        let paycodeRef = this.$refs.paycode;
        while (paycode.hasChildNodes()) {
          paycode.removeChild(paycode.firstChild);
        }
        let exitcode = document.querySelector('#exitcode');
        let exitcodeRef = this.$refs.exitcode;
        while (exitcode.hasChildNodes()) {
          exitcode.removeChild(exitcode.firstChild);
        }
        //生成二维码
        this.creatQrCode(payUrl, paycodeRef);
        this.creatQrCode(noPlateExitUrl, exitcodeRef);
      } else {
        let entercode = document.querySelector('#entercode');
        let entercodeRef = this.$refs.entercode;
        while (entercode.hasChildNodes()) {
          entercode.removeChild(entercode.firstChild);
        }
        //生成二维码
        this.creatQrCode(noPlateEnterUrl, entercodeRef);
      }
    });
  }
  // handleOk(e: any) {
  //   console.log(e)
  //   this.visible = false
  // }
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '通道名称',
        dataIndex: 'channelName',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属区域',
        dataIndex: 'areaName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '通道类型',
        dataIndex: 'channelType',
        width: 120,
        customRender: (text: any) => text || '--'
        // customRender: (text: string) => dictChannelTypeMap[text],
      },
      // {
      //   title: '所属终端',
      //   dataIndex: 'terminalName',
      //   width: 160,
      // },
      {
        title: '主摄像头',
        dataIndex: 'majorCameraName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: 'LED显示',
        dataIndex: 'displayName',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '道闸',
        dataIndex: 'roadGateName',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '使用状态',
        dataIndex: 'status',
        width: 80,
        // customRender: (text: any) => text || '--',
        // customRender: (text: any) => dictDeviceStatusMap[text],
        // scopedSlots: { customRender: 'deviceStatus' },
        scopedSlots: { customRender: 'status' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 300,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // 生命周期初始化表单
  created() {
    this.init();
    this.fetchTableData();
    this.rengetParkAreaList();
  }

  // 初始化form表单
  init() {
    if (this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { payUrl, noPlateEnterUrl, noPlateExitUrl } = this.dataForm;
          return {
            payUrl: this.$form.createFormField({
              value: payUrl
            }),
            noPlateEnterUrl: this.$form.createFormField({
              value: noPlateEnterUrl
            }),
            noPlateExitUrl: this.$form.createFormField({
              value: noPlateExitUrl
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this);
    }
  }
  //
  // 请求详情数据
  async showEditInfoChannelList() {
    try {
      const { status, code, msg, data } = await editInfoChannelList({ user: 1, channelId: this.channelId });
      const { datas } = data;
      this.detailList = datas;
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 请求数据列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await queryChannelList({
        parkId: this.listJson.parkIds.join(','),
        areaIds: this.listJson.areaIds.join(','),
        // parkId: this.parkAreaArr[0],
        // areaId: this.parkAreaArr[1],
        channelType: this.channelType,
        channelName: this.channelName,
        status: this.status,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  // 获取车场和区域下拉
  async rengetParkAreaList() {
    const { status, code, msg, data } = await getParkAreaList({});
    if (status === '9999') {
      this.parkAreaList = data;
    }
  }
  // 禁用启用事件
  async isforbiddenChange(row: any) {
    const { channelId } = row;
    this.channelId = channelId;
    const { status, msg, code, data } = await forbidChannelList({
      channelId,
      status: row.status === '生效' ? '00' : '01'
    });
    // console.log(res)
    if (status === '9999') {
      this.$message.success('操作成功');
      this.fetchTableData();
    } else {
      this.$message.error(msg);
    }
    // 调接口
    // this.getDisableEnabled(channelId)
  }

  // 模态框提交事件
  async handleSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.getShortCode(values);
        this.closeModelSub();
      }
    });
  }
  // 设置短码
  async getShortCode(values: any) {
    try {
      const { status, msg, code, data } = await setShortCode({
        parkId: this.checkParkId,
        channelId: this.channelId,
        ...values
      });
      if (status === '9999') {
        this.fetchTableData();
        this.$message.success('设置成功');
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '设置失败');
    }
  }
  //搜索
  searchTableData() {
    this.fetchTableData(true);
  }
  // 清空搜索条件
  onTableFilterClear() {
    this.channelName = '';
    this.parkId = '';
    // @ts-ignore
    this.areaId = '';
    this.listJson.areaIds = [];
    this.listJson.parkIds = [];
    this.status = '02';
    this.channelType = '';
    this.parkAreaArr = [];
    this.fetchTableData(true);
  }
  // 跳转到编辑
  toUpdate(channelId: string) {
    this.$router.push({
      name: CHANNEL_LIST_EDIT,
      params: {
        channelId
      }
    });
  }

  // 新增跳转
  toCreate() {
    this.$router.push({
      name: CHANNEL_LIST_CREATE
    });
  }
  // 跳通道授权
  toChannelGrant(row: any) {
    const { areaId, parkId, channelId } = row;
    this.$router.push({
      name: CHANNEL_LIST_GRANT,
      params: {
        channelId
      },
      query: {
        areaId,
        parkId
      }
    });
  }
  //复制链接
  copyUrl(e) {
    const _input = document.createElement('input');
    // 直接构建input
    _input.value = e || ' ';
    // 设置内容
    document.body.appendChild(_input); // 添加临时实例
    _input.select(); // 选择实例内容
    document.execCommand('Copy'); // 执行复制
    this.$message.success('复制成功');
    document.body.removeChild(_input); // 删除临时实例
  }
  //保存短码设置
  async saveFlag() {
    try {
      const { payUrl, noPlateEnterUrl, noPlateExitUrl } = this.dataForm;
      let setForm;
      if (this.isShowEnter) {
        setForm = { payUrl, noPlateExitUrl };
      } else {
        setForm = { noPlateEnterUrl };
      }
      const { payUrlStatus, noPlateEnterUrlStatus, noPlateExitUrlStatus } = this.shortCodeForm;
      const shForm = this.isShowEnter
        ? { payUrlStatus: payUrlStatus ? '01' : '00', noPlateExitUrlStatus: noPlateExitUrlStatus ? '01' : '00' }
        : { noPlateEnterUrlStatus: noPlateEnterUrlStatus ? '01' : '00' };
      const res = await enableOrDisabledShortCode({ channelId: this.channelId, ...shForm, ...setForm });
      this.$message.success('设置成功');
      this.isvisible = false;
      this.fetchTableData();
    } catch (e) {
      console.log(e);
    }
  }
  changeSelect(value: _.List<never>, label: any, extra: any) {
    if (extra.allCheckedNodes && extra.allCheckedNodes.length > 0) {
      if (extra.allCheckedNodes[0].pos) {
        const { parkIds, areaIds } = this.getParkAndArea(extra.allCheckedNodes);
        this.listJson.parkIds = parkIds;
        this.listJson.areaIds = areaIds;
      } else {
        this.listJson.areaIds = _.intersection(this.listJson.areaIds, value);
        // this.listJson.parkIds = _.intersection(this.listJson.parkIds, value)
        // for(let i=0;i<value.length;i++){
        // }
      }
    } else {
      this.listJson = { areaIds: [], parkIds: [] };
    }
    console.log('this.json===>', this.listJson);
  }
  /**
   * 导出事件
   */
  // exportHandle
  // async exportHandle() {
  //   try {
  //     const { status, code, msg, data } = await exportChannelList(this.filterParam)
  //     // 成功
  //   } catch (error) {
  //     console.log('queryParkList error')
  //   }
  // }
  //获取车场id和区域id
  getParkAndArea(allCheckedNodes: any[] = []) {
    const parkIds: any[] = [];
    const areaIds: any[] = [];
    if (allCheckedNodes.length < 1) return { parkIds, areaIds };
    for (let i = 0; i < allCheckedNodes.length; i++) {
      // @ts-ignore
      const arr = allCheckedNodes[i].pos.split('-');
      if (arr.length > 2) {
        let arrIndex = arr[1];
        //子节点 都是区域
        // @ts-ignore
        areaIds.push(allCheckedNodes[i].node.key);
        parkIds.push(this.parkAreaList[arrIndex].value);
      } else {
        //根节点 是车场
        // @ts-ignore
        parkIds.push(allCheckedNodes[i].node.key);
        // @ts-ignore
        if (allCheckedNodes[i].children && allCheckedNodes[i].children.length > 0) {
          // @ts-ignore
          let areaListj = allCheckedNodes[i].children;
          for (let j = 0; j < areaListj.length; j++) {
            areaIds.push(areaListj[j].node.key);
          }
        }
      }
    }
    return { parkIds: _.uniq(parkIds), areaIds: _.uniq(areaIds) };
  }

  /**
   * 切换启用禁用状态
   */
  switchStatus(text, checked) {
    console.log(text, checked);
  }

  //创建二维码
  creatQrCode(url, obj) {
    var qrcode = new QRCode(obj, {
      text: url, // 需要转换为二维码的内容
      width: 200,
      height: 200,
      colorDark: '#000000',
      colorLight: '#ffffff'
    });
  }
  // 下载图片
  downloadQrcode(type: string) {
    // var canvas = document.createElement('canvas')
    // var img = document.createElement('img')
    // img.onload = function(e) {
    //   canvas.width = img.width
    //   canvas.height = img.height
    //   var context = canvas.getContext('2d')
    //   context.drawImage(img, 0, 0, img.width, img.height)
    //   canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
    //   canvas.toBlob(blob => {
    //     let link = document.createElement('a')
    //     link.href = window.URL.createObjectURL(blob)
    //     link.download = '小程序码图片'
    //     link.click()
    //   }, 'image/jpeg')
    // }
    // img.setAttribute('crossOrigin', 'Anonymous')
    // img.src = 'https://parking-file-uat.oss-cn-shenzhen.aliyuncs.com/parkImage/20201201111248523019076005700357.png'
    let href = '';
    if (type === 'pay') {
      href = this.imgPayUrl;
    } else if (type === 'exit') {
      href = this.imgNoPlateExitUrl;
    } else {
      href = this.imgNoPlateEnterUrl;
    }
    let link = document.createElement('a');
    link.href = href;
    link.download = '小程序码图片';
    link.click();
  }
  //点击下载二维码
  downLoadCode(type, data) {
    let myCanvas: any = '';
    let img: any = '';
    let typeName = '';
    if (type == '00') {
      myCanvas = document.getElementById('paycode').getElementsByTagName('canvas');
      img = document.getElementById('paycode');
      typeName = '支付码';
    } else if (type == '01') {
      myCanvas = document.getElementById('exitcode').getElementsByTagName('canvas');
      img = document.getElementById('exitcode');
      typeName = '出场码';
    } else if (type == '02') {
      myCanvas = document.getElementById('entercode').getElementsByTagName('canvas');
      img = document.getElementById('entercode');
      typeName = '入场码';
    }
    const codeName: string = data.parkName + '-' + data.channelName + '-' + typeName;
    this.downs(codeName, myCanvas, img);
  }
  //把二维码下载到本地
  downs(codeName, myCanvas, img) {
    let a = document.createElement('a');
    // //设置a标签的href属性（将canvas变成png图片）
    let imgURL = myCanvas[0].toDataURL('image/jpg');
    let ua = navigator.userAgent;
    if (ua.indexOf('Trident') != -1 && ua.indexOf('Windows') != -1) {
      // IE内核 并且  windows系统 情况下 才执行;
      var bstr = atob(imgURL.split(',')[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var blob = new Blob([u8arr]);
      window.navigator.msSaveOrOpenBlob(blob, codeName + '.' + 'png');
    } else if (ua.indexOf('Firefox') > -1) {
      //火狐兼容下载
      let blob = this.base64ToBlob(imgURL); //new Blob([content]);
      let evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      a.download = ' '; //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
      a.href = URL.createObjectURL(blob);
      a.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    } else {
      //谷歌兼容下载
      img.src = myCanvas[0].toDataURL('image/jpg');
      a.href = img.src;
      //设置下载文件的名字
      a.download = codeName;
      //点击
      a.click();
    }
  }
  //bse64 转成 Bold
  base64ToBlob(code) {
    let parts = code.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }
  codeVisible: boolean = false;
  //显示二维码弹框
  showCode(record) {
    console.log(record);
    this.codeVisible = true;
    this.imgParkId = record.parkId;
    this.imgChannelId = record.channelId;
    this.imgChannelType = record.channelType === '入口' ? '00' : '01';
    if (this.imgChannelType === '00') {
      this.getQRCodeDetail('');
    } else {
      this.getQRCodeDetail('pay');
      this.getQRCodeDetail('exit');
    }
  }
  //关闭二维码弹框
  handleCancelCode() {
    this.codeVisible = false;
  }
  qrCodeLoading1: boolean = false;
  qrCodeLoading2: boolean = false;
  qrCodeLoading3: boolean = false;
  imgParkId: string = '';
  imgChannelId: string = '';
  imgChannelType: string = '';
  imgNoPlateEnterUrl: string = ''; // 无牌车入场码
  imgPayUrl: string = ''; // 通道支付码
  imgNoPlateExitUrl: string = ''; // 无牌车出场码
  payOrExit: string = '';
  // 获取时代二维码
  async getQRCodeDetail(payOrExit?: string, refresh: boolean = false) {
    this.formData.parkName = '';
    this.formData.areaName = '';
    this.formData.channelName = '';
    try {
      if (this.imgChannelType === '00') {
        this.qrCodeLoading1 = true;
        this.imgNoPlateEnterUrl = '';
      } else {
        if (payOrExit === 'pay') {
          this.qrCodeLoading2 = true;
          this.imgPayUrl = '';
        } else {
          this.qrCodeLoading3 = true;
          this.imgNoPlateExitUrl = '';
        }
      }
      const { status, msg, code, data } = await getChannelQRCode({
        parkId: this.imgParkId,
        channelId: this.imgChannelId,
        channelType: this.imgChannelType,
        payOrExit: payOrExit,
        refresh: refresh
      });
      if (status === '9999') {
        this.formData.parkName = data.parkName;
        this.formData.areaName = data.areaName;
        this.formData.channelName = data.channelName;
        if (this.imgChannelType === '00') {
          this.imgNoPlateEnterUrl = `${API_SERVER.imgBaseUrl}${data.noPlateEnterUrl}`;
        } else {
          if (payOrExit === 'pay') {
            this.imgPayUrl = `${API_SERVER.imgBaseUrl}${data.payUrl}`;
          } else {
            this.imgNoPlateExitUrl = `${API_SERVER.imgBaseUrl}${data.noPlateExitUrl}`;
          }
        }
      }
    } catch (error) {
      console.log(error);
      // this.$message.error((error && error.msg) || '系统繁忙，请稍后再试')
    } finally {
      this.qrCodeLoading1 = false;
      this.qrCodeLoading2 = false;
      this.qrCodeLoading3 = false;
    }
  }
  // 刷新
  refreshQrcode(payOrExit) {
    this.getQRCodeDetail(payOrExit, true);
  }
}
